export default {
  SET_INTERNAL_CHAT_CONVERSATIONS: 'SET_INTERNAL_CHAT_CONVERSATIONS',
  UPSERT_INTERNAL_CHAT_CONVERSATION: 'UPSERT_INTERNAL_CHAT_CONVERSATION',
  UPDATE_INTERNAL_CHAT_CONVERSATION_ACTIVITY:
    'UPDATE_INTERNAL_CHAT_CONVERSATION_ACTIVITY',
  SET_INTERNAL_CHAT_CONVERSATION_UNREAD_COUNT:
    'SET_INTERNAL_CHAT_CONVERSATION_UNREAD_COUNT',
  INCREMENT_INTERNAL_CHAT_UNREAD_COUNT: 'INCREMENT_INTERNAL_CHAT_UNREAD_COUNT',
  SET_INTERNAL_CHAT_MESSAGES: 'SET_INTERNAL_CHAT_MESSAGES',
  PREPEND_INTERNAL_CHAT_MESSAGES: 'PREPEND_INTERNAL_CHAT_MESSAGES',
  ADD_INTERNAL_CHAT_MESSAGE: 'ADD_INTERNAL_CHAT_MESSAGE',
  MARK_INTERNAL_CHAT_MESSAGES_READ: 'MARK_INTERNAL_CHAT_MESSAGES_READ',
  SET_INTERNAL_CHAT_ACTIVE_CONVERSATION_ID:
    'SET_INTERNAL_CHAT_ACTIVE_CONVERSATION_ID',
  CLEAR_INTERNAL_CHAT_ACTIVE_CONVERSATION_ID:
    'CLEAR_INTERNAL_CHAT_ACTIVE_CONVERSATION_ID',
  SET_INTERNAL_CHAT_UI_FLAG: 'SET_INTERNAL_CHAT_UI_FLAG',
};
